import { Router, browserHistory as history } from 'react-router'
import HistoryTracker from 'back-forward-history'

import * as h from 'h'

import UiStore from 'stores/UiStore'

import Container from 'containers/Container'
import Landing from 'containers/Landing'

import About from 'containers/About'
import Explore from 'containers/Explore'
import Expertise from 'containers/Expertise'
import NewsEvents from 'containers/NewsEvents'
import NotFound from 'containers/NotFound'
import Resources from 'containers/Resources'
import Search from 'containers/Search'

import Popout from 'components/Popout'

function ure (name) {
  return function () {
    UiStore.rootRouteTransition(name)
  }
}

history.listen(e => UiStore.routeTransition(e))

HistoryTracker.listenTo(history)

function popoutRoutes () {
  // Load popout on the Search container instead of jumping containers.
  const altParent = UiStore.route === 'search' ? Search : null
  // Similar situation when viewing faculty while explore research grants and IP
  const viewFacultyFromExplore = UiStore.route === 'explore' ? Explore : null

  return [
    { component: altParent || Explore, childRoutes: [{ path: 'ip/:id(/:name)', component: Popout }] },
    { component: altParent || Explore, childRoutes: [{ path: 'research/:id(/:name)', component: Popout }] },
    { component: altParent || Explore, childRoutes: [{ path: 'companies/:id(/:name)', component: Popout }] },
    { component: altParent || Resources, childRoutes: [{ path: 'resource/:id(/:name)', component: Popout }] },
    { component: altParent || NewsEvents, onEnter: ure('news'), childRoutes: [{ path: 'news/:id(/:name)', component: Popout }] },
    { component: altParent || viewFacultyFromExplore || Expertise, childRoutes: [{ path: 'faculty/:id(/:name)', component: Popout }] }
  ]
}

const routes = {
  path: '/',
  component: Container,
  indexRoute: { onEnter: ure('landing'), component: Landing },
  getChildRoutes (_, cb) {
    cb(null, [
      { path: 'technologies', onEnter: ure('technologies'), component: Explore },
      { path: 'startups', onEnter: ure('startups'), component: Explore },
      { path: 'expertise', onEnter: ure('expertise'), component: Expertise },
      { path: 'resources', onEnter: ure('resources'), component: Resources },
      { path: 'news', onEnter: ure('news'), component: NewsEvents },
      { path: 'search', onEnter: ure('search'), component: Search },
      { path: 'about', onEnter: ure('about'), component: About },
      ...popoutRoutes(),
      { component: About, childRoutes: [{ path: 'about/:id(/:name)', component: About }] },
      { path: '*', onEnter: ure('not-found'), component: NotFound }
    ])
  }
}

export default h.h(Router, { routes, history })



// WEBPACK FOOTER //
// ./resources/assets/js/routes.js